import React from 'react';
import SkeletonLoader from './SkeletonLoader';

const CustomerAccountSkeleton = () => {
  return (
    <div className="main-content-container">
      {/* Header */}
      <div className="account-header">
        <div className="skeleton-customer-account-title skeleton-loader"></div>
        <div className="skeleton-customer-account-subtitle skeleton-loader"></div>
      </div>

      <div className="account-content">
        {/* Sezione Informazioni Personali */}
        <div className="account-section">
          <div className="section-header">
            <div className="skeleton-customer-account-section-title skeleton-loader"></div>
            <div className="skeleton-customer-account-edit-button skeleton-loader"></div>
          </div>

          <div className="info-display">
            <div className="info-row">
              <div className="info-group">
                <div className="skeleton-customer-account-info-label skeleton-loader"></div>
                <div className="skeleton-customer-account-info-value skeleton-loader"></div>
              </div>
              <div className="info-group">
                <div className="skeleton-customer-account-info-label skeleton-loader"></div>
                <div className="skeleton-customer-account-info-value skeleton-loader"></div>
              </div>
            </div>
            
            <div className="info-group">
              <div className="skeleton-customer-account-info-label skeleton-loader"></div>
              <div className="skeleton-customer-account-info-value skeleton-loader"></div>
            </div>

            <div className="info-group">
              <div className="skeleton-customer-account-info-label skeleton-loader"></div>
              <div className="skeleton-customer-account-info-value skeleton-loader"></div>
            </div>

            <div className="info-group">
              <div className="skeleton-customer-account-info-label skeleton-loader"></div>
              <div className="skeleton-customer-account-info-value skeleton-loader"></div>
            </div>
          </div>
        </div>

        {/* Sezione Azioni Account */}
        <div className="account-section">
          <div className="skeleton-customer-account-section-title skeleton-loader"></div>
          <div className="actions-grid">
            <div className="action-card">
              <div className="skeleton-customer-account-action-icon skeleton-loader"></div>
              <div className="skeleton-customer-account-action-title skeleton-loader"></div>
              <div className="skeleton-customer-account-action-description skeleton-loader"></div>
              <div className="skeleton-customer-account-action-button skeleton-loader"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerAccountSkeleton; 